// O que aplicar da resposta do ViaCEP no endereço que está na tela agora.
//
// A busca leva um tempo, e nesse meio-tempo a pessoa pode ter trocado o CEP
// ou digitado a rua à mão. Resposta de um CEP que não é mais o do campo não
// entra (preencheria rua e cidade de outro lugar — no checkout, o pedido
// iria para o endereço errado), e campo editado depois de a busca começar
// fica como a pessoa escreveu. Valor vazio na resposta (CEP só de cidade
// volta sem rua) não apaga o que já estava escrito.
//
// Sem import de propósito: roda no Node (`viaCep.check.mjs`).
const digitos = (v) => String(v || "").replace(/\D/g, "");

export const aplicarViaCep = (atual, consultado, resposta, editadosDepois = []) => {
	if (!resposta || digitos(atual?.cep) !== digitos(consultado)) return {};
	return Object.fromEntries(
		Object.entries(resposta).filter(([campo, v]) => v && !editadosDepois.includes(campo)),
	);
};
